const u = String(window.navigator.userAgent).toLowerCase();

const isAndroid = () => {
    return u.indexOf('android') > -1;
}

const isSafari = () => {
    return u.indexOf('safari') > -1;
}

const isFxiOS = () => {
    return u.indexOf('fxios') > -1;
}

const isChrome = () => {
    return u.indexOf('crios') > -1 || u.indexOf('chrome') > -1;
}

const isUC = () => {
    return u.indexOf('ucbrowser') > -1;
}

const isIphone = () => {
    return u.indexOf('iphone') > -1;
}

const isIPad = () => {
    return u.indexOf('ipad') > -1;
}

const isMiuiBrowser = () => {
    return u.indexOf('miuibrowser') > -1;
}

const isQQBrowser = () => {
    return u.indexOf('mqqbrowser') > -1;
}

const isBaiduBrowser = () => {
    return u.indexOf('baidubrowser') > -1;
}

const isAoyouBrowser = () => {
    return u.indexOf('isAoyouBrowser') > -1;
}

const isQihooBrowser = () => {
    return u.indexOf('isQihooBrowser') > -1;
}

const getPlatform = () => {
    if (u.indexOf('egretwebview') > -1) {
        if (isIphone()) {
            return 1;
        } else if (isAndroid()) {
            return 2;
        } else {
            return 0;
        }
    } else {
        return 0;
    }
}

class Browser {
    constructor() {

    }
    isSupportBrowser() {
        //是否支持的浏览器
        return isIphone() && !isMiuiBrowser() && isSafari() && !isChrome() && !isQQBrowser() && !isFxiOS() && !
            isQihooBrowser() && !isUC() && !isBaiduBrowser() && !isAoyouBrowser() && getPlatform() == 0;
    }
    isShowTips() {
        //是否提示用户使用Safari浏览器
        return isIphone() && (isChrome() || isQQBrowser() || isFxiOS() || isQihooBrowser() || isUC() || isBaiduBrowser() ||
            isAoyouBrowser());
    }
    getDirection() {
        //获取浏览器垂直方向，是横屏还是竖屏
        if (window.orientation == 180 || window.orientation == 0) {
            return 'vertical'; //竖屏
        }
        if (window.orientation == 90 || window.orientation == -90) {
            return 'horizontal'; //横屏
        }
        return 'horizontal'; //横屏
    }
    getPlatform() {
        //获取当前平台-------> 1:iOS 2:Android 0:Web
        return getPlatform();
    }
    isIPad() {
        //是否是Ipad访问
        return isIPad();
    }
    isIos() {
        //判断是否是ios平台
        return isIphone() || isIPad();
    }
    isMobile() {
        //判断是否是移动设备
        return isIphone() || isIPad() || isAndroid();
    }
    isPcChrome() {
        //判断是否是PC Chrome浏览器，用于此浏览器字体大小最小12px时候做Hack
        return !this.isMobile() && isChrome();
    }
    isAndroid() {
        return isAndroid();
    }
}

export default Browser;